// extracted by mini-css-extract-plugin
module.exports = {"titleBar":"TitleButton_titleBar__3h9p7","title":"TitleButton_title__1ehih","button":"TitleButton_button__2dWP-"};